angular.module('angus.controllers').controller('bsgServiceMarginSettingsCtrl', [
    '$scope', '_', 'constantsService',
    function($scope, _, constantsService) {

        'use strict';

        $scope.periodIndicators      = constantsService.servicePeriodIndicators.enums;                
    }
]);
